export default function isZocdocBrand(directoryId) {
    // -2 is test directory (currently used for flapjack)
    return directoryId === '-1' || directoryId === '-2';
}
